import { render, staticRenderFns } from "./guestbook.html?vue&type=template&id=752e664b&scoped=true&external"
import script from "./Guestbook.vue?vue&type=script&lang=js"
export * from "./Guestbook.vue?vue&type=script&lang=js"
import style0 from "./Guestbook.vue?vue&type=style&index=0&id=752e664b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752e664b",
  null
  
)

export default component.exports